export const BET_TIPS = 'BET_TIPS';
export const TOP_INFO = 'TOP_INFO';
export const SAVED_BETS = 'SAVED_BETS';
export const RACE_INFO = 'RACE_INFO';

const popupMenuTypes = {
  BET_TIPS,
  TOP_INFO,
  SAVED_BETS,
  RACE_INFO,
};

export default popupMenuTypes;
